import { StateNode, TLStateNodeConstructor } from "tldraw"
import { TextIdle } from "./TextIdle"
import { TextPointing } from "./TextPointing"

export class TextTool extends StateNode {
  static override id = "text2"
  static override initial = "text-idle"
  static override children(): TLStateNodeConstructor[] {
    return [TextIdle, TextPointing]
  }
  override shapeType = "text2"
}
